export const BACKEND_SERVER_ADDRESS = `http://54.237.212.153:5000`;
export const GET_EVERY_PROJECT_DATA_API_ADDRESS = `${BACKEND_SERVER_ADDRESS}/api/admin/get-projects`;
